import { Link } from 'react-router-dom';
import { Text, Image, Icon, useBreakpoint, Breakpoint, useBreakpointProp } from '@betty/moonlight';
import styles from './DownloadAppSection.module.css';
import React from 'react';
import { TypographyNames } from '@betty/moonlight/lib/common/Text/Text.types';

function DownloadAppSection() {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const titleSize = useBreakpointProp({
    mobile: 'h5',
    tablet: 'h5',
    desktop: 'h4',
  }) as TypographyNames;

  return (
    <div className={styles.downloadAppSection}>
      <div className={styles.infoContainer}>
        <div className={styles.coinsPhone}>
          <Image name="landingPage.coinsPhone" width={248} height={232} />
        </div>
        <Image
          name={
            isMobile
              ? 'landingPage.downloadAppMobile'
              : 'landingPage.downloadAppDesktop'
          }
          height={230}
          width="100%"
          position="absolute"
          contentFit="cover"
          borderRadius="radius-400"
        />
        <div className={styles.textWrapper}>
          <Text
            variant={titleSize}
            maxWidth={{
              desktop: 610,
              tablet: 610,
              mobile: 204,
            }}
            marginBottom="space-400"
            gradient="darkSurfaceAccent"
          >
            Experience the Betty fun on your iPhone
          </Text>
          <Link to="https://apps.apple.com/ca/app/betty-casino-real-money-slots/id6743212841">
            <Icon name="appStore" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default DownloadAppSection;
